export const validateMoroccanPhone = (phone: string): boolean => {
    // Accepts formats like: +212600000000, 0600000000, 0500000000
    // Removes spaces and dashes before checking
    const cleaned = phone.replace(/[\s-]/g, '');
    const regex = /^(?:\+212|0)[5-7]\d{8}$/;
    return regex.test(cleaned);
};
